/* ============================================================
   PuffyGlo — Peak Design Theme JS
   pd-theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── FAQ ACCORDION ─── */
  document.querySelectorAll('.pd-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = btn.classList.contains('open');
      // Close all
      document.querySelectorAll('.pd-faq__q').forEach(function (b) {
        b.classList.remove('open');
        var a = b.nextElementSibling;
        if (a && a.classList.contains('pd-faq__a')) a.classList.remove('open');
      });
      // Toggle clicked
      if (!isOpen) {
        btn.classList.add('open');
        var ans = btn.nextElementSibling;
        if (ans && ans.classList.contains('pd-faq__a')) ans.classList.add('open');
      }
    });
  });

  /* ─── MOBILE NAV TOGGLE ─── */
  var hamburger = document.querySelector('.pd-nav__hamburger');
  var mobileNav = document.querySelector('.pd-mobile-nav');
  var mobileClose = document.querySelector('.pd-mobile-nav__close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('open');
      mobileNav.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      mobileClose?.focus();
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('open');
      mobileNav.setAttribute('aria-hidden', 'true');
      hamburger?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger?.focus();
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && mobileNav && mobileNav.classList.contains('open')) {
      mobileClose?.click();
    }
  });

  /* ─── STICKY NAV SHADOW ON SCROLL ─── */
  var nav = document.querySelector('.pd-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        nav.style.boxShadow = '0 2px 20px rgba(0,0,0,0.08)';
      } else {
        nav.style.boxShadow = '';
      }
    }, { passive: true });
  }

  /* ─── ANNOUNCEMENT BAR AUTO CYCLE ─── */
  var announcements = document.querySelectorAll('.pd-announce__msg');
  if (announcements.length > 1) {
    var idx = 0;
    setInterval(function () {
      announcements[idx].style.display = 'none';
      idx = (idx + 1) % announcements.length;
      announcements[idx].style.display = 'block';
    }, 4000);
  }

  /* ─── CART COUNT BADGE ─── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.pd-nav__cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(function () {});
  }
  updateCartCount();

  /* ─── MODULAR DRAWERS (ACCORDIONS) ─── */
  document.querySelectorAll('[data-drawer-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var root = trigger.closest('[data-drawer-root]');
      var content = root.querySelector('[data-drawer-content]');
      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
      trigger.setAttribute('aria-expanded', !isExpanded);
      if (isExpanded) {
        content.hidden = true;
      } else {
        content.hidden = false;
      }
    });
  });

  /* ─── EMAIL FORM SUBMIT ─── */
  var emailForm = document.querySelector('.pd-email__form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = emailForm.querySelector('.pd-email__input');
      var btn = emailForm.querySelector('.pd-email__btn');
      if (!input || !input.value) return;
      btn.textContent = 'Subscribed ✓';
      btn.style.background = 'var(--pd-green)';
      input.value = '';
      input.placeholder = 'Thanks! You\'re on the list.';
      setTimeout(function () {
        btn.textContent = 'Subscribe';
        btn.style.background = '';
        input.placeholder = 'Your email address';
      }, 4000);
    });
  }

  /* ─── MOTION PRECISION (FADE-IN OBSERVER) ─── */
  var observerOptions = {
    root: null,
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.pd-section-header h2, .pd-hero__heading, .pd-title, .pd-cat-card, .pd-split__card').forEach(function(el) {
    el.classList.add('fade-in-up');
    observer.observe(el);
  });

});
